import {Directive, ElementRef, OnInit} from "@angular/core";
import * as uuid from "uuid";

type HTMLInputOrSelect = HTMLInputElement | HTMLSelectElement;

@Directive({
  selector: "[autoLinkToLabel]",
})
export class AutoLinkToLabelDirective implements OnInit {
  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    const children = Array.from(this.elementRef.nativeElement.parentElement.children) as HTMLElement[];
    const inputs = children.filter(it => (it.tagName === "INPUT" || it.tagName === "SELECT")) as HTMLInputOrSelect[];
    const labels = children.filter(it => it.tagName === "LABEL") as HTMLLabelElement[];

    if (inputs.length === 1 && labels.length === 1) {
      const input = inputs[0];
      const label = labels[0];

      if (!input.id) {
        const uniqueId = uuid.v1().replace(/-/g, "").toUpperCase();
        input.id = `INPUT_${uniqueId}`;
      }

      label.htmlFor = input.id;
    }
  }
}
